module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": _vm.articleInfo.imgPath,
      "alt": _vm.articleInfo.title + ' Image'
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleInfo.title))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a2997540!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article-tile.vue
// module id = 280
// module chunks = 2